import { FC } from "react";
import Collapsible from "react-collapsible";
import { LoyaltyTagStatusVariantT } from "components/atoms/LoyaltyTagStatusRank/types";
import { StatusRank } from "components/atoms/LoyaltyRankStatus/types";
import LoyaltyListRewards from "components/molecules/LoyaltyListRewards";
import LoyaltyTagStatusRank from "components/atoms/LoyaltyTagStatusRank";
import { RewardItemT } from "components/molecules/LoyaltyListRewards/types";
import useTranslate from "hooks/useTranslate";
import IconArrow from "assets/icons/loyalty/arrow_rank.svg?react";
import classNames from "classnames";
import { getHeightProgress } from "./utils";
import "./styles.sass";

type LoyaltyRankDetailMobileProps = {
  userExperience: number;
  name: string;
  isOpen: boolean;
  statusRank: LoyaltyTagStatusVariantT;
  statusRankRewards: StatusRank;
  rewardsRank: RewardItemT[];
  levels: Array<{
    title: string;
    status: StatusRank;
    rewards: RewardItemT[];
    requirement: number;
    nextRequirement: number;
  }>;
  image?: string;
  handleClick: () => void;
  isLastRank: boolean;
  isFirst: boolean;
};

// Никак не трогать компонент ! ОБращаться к Роме ес шо
const LoyaltyRankDetailMobile: FC<LoyaltyRankDetailMobileProps> = (
  props: LoyaltyRankDetailMobileProps,
) => {
  const {
    userExperience,
    name,
    isOpen,
    statusRank,
    image,
    levels,
    statusRankRewards,
    rewardsRank,
    handleClick,
    isLastRank,
    isFirst,
  } = props;
  const t = useTranslate();

  const heightProgress = getHeightProgress(
    userExperience,
    rewardsRank,
    levels,
    isOpen,
    isLastRank,
    isFirst,
  );

  const classNameCircle = classNames(
    "LoyaltyRankDetailMobile__circle",
    statusRank !== "nextRank" && "LoyaltyRankDetailMobile__circle_bordered",
    isFirst && "LoyaltyRankDetailMobile__circle_first",
  );

  const classNameProgress = classNames(
    "LoyaltyRankDetailMobile__progress",
    isFirst && "LoyaltyRankDetailMobile__progress_first",
  );

  return (
    <div className="LoyaltyRankDetailMobile">
      <div className="LoyaltyRankDetailMobile__info">
        <div className="LoyaltyRankDetailMobile__left">
          <LoyaltyTagStatusRank status={statusRank} />
          <h3 className="LoyaltyRankDetailMobile__name">
            {t(name)}
            <IconArrow
              className={classNames(
                "LoyaltyRankDetailMobile__arrow",
                isOpen && "LoyaltyRankDetailMobile__arrow_open",
              )}
              onClick={handleClick}
            />
          </h3>
        </div>
        <img
          src={image}
          alt="image-rank"
          className="LoyaltyRankDetailMobile__image"
        />
      </div>
      <Collapsible open={isOpen} transitionTime={200} trigger="">
        <div className="LoyaltyRankDetailMobile__rewards">
          {!!rewardsRank && rewardsRank?.length > 0 && (
            <>
              <LoyaltyListRewards
                title=""
                rewards={rewardsRank}
                status={statusRankRewards}
                isRank
              />
              <hr className="LoyaltyRankDetailMobile__line" />
            </>
          )}
          <div className="LoyaltyRankDetailMobile__listLevels">
            {levels?.map((level, index, arr) => (
              <LoyaltyListRewards
                key={level.title}
                title={level.title}
                rewards={level.rewards}
                status={level.status}
                withProgress={isOpen}
                userExperience={userExperience}
                requirement={level.requirement}
                nextRequirement={level.nextRequirement}
                isLast={arr.length - 1 === index}
              />
            ))}
          </div>
        </div>
      </Collapsible>
      <div className={classNameProgress}>
        <div
          className="LoyaltyRankDetailMobile__progressInner"
          style={{ height: heightProgress }}
        />
        <div className={classNameCircle} />
      </div>
    </div>
  );
};

export default LoyaltyRankDetailMobile;
